import { useState } from "react";

import i18n from "@microdoing/shared/i18n";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getChallengeReminderTime,
  getHasChallengeReminder,
  getUserId,
} from "@microdoing/shared/services/user/selectors";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import { getActiveStep } from "@microdoing/shared/services/userCampaign/selectors";
import { useNavigation } from "@react-navigation/native";

import hasNotificationPermission from "app/utils/hasNotificationPermission";
import {
  modifyUser,
  updateUserWithoutResponseRequest,
} from "@microdoing/shared/services/user/actions";

import {
  cancelChallengeReminderNotif,
  scheduleChallengeNotif,
} from "@microdoing/shared/services/notifService";
import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import removeHtmlTags from "@microdoing/shared/utils/removeHtmlTags";
import { showAlert } from "@microdoing/shared/services/profileSettings/actions";

export const useAddReminder = () => {
  const [isTimePickerVisible, setIsTimePickerVisible] = useState(false);

  const hasChallengeReminder = useSelector(getHasChallengeReminder);
  const challengeReminderTime = useSelector(getChallengeReminderTime);
  const userId = useSelector(getUserId);
  const language = useSelector(getLanguage);
  const item = useSelector(getActiveStep);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  const removeReminder = () => {
    dispatch(modifyUser({ hasChallengeReminder: false }));
    dispatch(
      updateUserWithoutResponseRequest({ userId, hasChallengeReminder: false }),
    );
    cancelChallengeReminderNotif();
  };

  const openTimePicker = () => {
    setIsTimePickerVisible(true);
  };

  const onCancel = () => setIsTimePickerVisible(false);

  const onConfirm = async time => {
    try {
      const hasNotificationsEnabled = await hasNotificationPermission();
      const challengeReminderTime = { hour: 0, minute: 0 };
      const hour = moment(time).hour();
      const minute = moment(time).minute();
      setIsTimePickerVisible(false);
      dispatch(
        updateUserWithoutResponseRequest({
          userId,
          hasChallengeReminder: true,
          challengeReminderTime: challengeReminderTime,
        }),
      );

      if (!hasNotificationsEnabled) {
        return navigation.navigate("AllowNotifications"); // a tester
      }
      cancelChallengeReminderNotif();
      challengeReminderTime.hour = hour;
      challengeReminderTime.minute = minute;

      dispatch(
        modifyUser({ challengeReminderTime, hasChallengeReminder: true }),
      );

      const title = item?.title;
      const actionTitle = selectLanguage({ text: title, language });
      const text = item?.content?.title;
      const challengeText = removeHtmlTags(
        selectLanguage({ text: text, language }),
      );
      scheduleChallengeNotif(challengeReminderTime, actionTitle, challengeText);

      dispatch(showAlert({ title: i18n.t("save-success") }));
    } catch (e) {
      console.log(e);
    }
  };

  return [
    isTimePickerVisible,
    openTimePicker,
    removeReminder,
    onConfirm,
    onCancel,
    hasChallengeReminder,
    challengeReminderTime,
  ] as const;
};
